var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDropdownIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21934 10.2198C5.35997 10.0794 5.55059 10.0005 5.74934 10.0005C5.94809 10.0005 6.13871 10.0794 6.27934 10.2198L7.99934 11.9398L9.71934 10.2198C9.788 10.1461 9.8708 10.087 9.9628 10.046C10.0548 10.0051 10.1541 9.98301 10.2548 9.98124C10.3555 9.97946 10.4555 9.99798 10.5489 10.0357C10.6423 10.0734 10.7272 10.1296 10.7984 10.2008C10.8696 10.272 10.9257 10.3568 10.9635 10.4502C11.0012 10.5436 11.0197 10.6436 11.0179 10.7444C11.0162 10.8451 10.9941 10.9444 10.9531 11.0364C10.9121 11.1284 10.853 11.2112 10.7793 11.2798L8.52934 13.5298C8.38871 13.6703 8.19809 13.7492 7.99934 13.7492C7.80059 13.7492 7.60997 13.6703 7.46934 13.5298L5.21934 11.2798C5.07889 11.1392 5 10.9486 5 10.7498C5 10.5511 5.07889 10.3605 5.21934 10.2198ZM10.7793 5.77983C10.6387 5.92028 10.4481 5.99917 10.2493 5.99917C10.0506 5.99917 9.85997 5.92028 9.71934 5.77983L7.99934 4.05983L6.27934 5.77983C6.13717 5.91231 5.94912 5.98443 5.75482 5.981C5.56052 5.97758 5.37513 5.89886 5.23772 5.76145C5.10031 5.62404 5.02159 5.43865 5.01817 5.24435C5.01474 5.05005 5.08686 4.862 5.21934 4.71983L7.46934 2.46983C7.60997 2.32938 7.80059 2.25049 7.99934 2.25049C8.19809 2.25049 8.38871 2.32938 8.52934 2.46983L10.7793 4.71983C10.9198 4.86045 10.9987 5.05108 10.9987 5.24983C10.9987 5.44858 10.9198 5.6392 10.7793 5.77983Z",
    fill: "#5D6165"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDropdownIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dropdown_icon.be848645dbb789359f7d9e744072f84b.svg";